import axios from "axios";
import {EnvironmentConfig} from "@me8eon/config";
import { aiConfig } from "me-at-eon/src";

export const HttpServicePostLiveAgentChat = async () => {
    const { jwtTokenFn } = aiConfig;
    const client_id =
        EnvironmentConfig.snowClientIdLiveAgentChat || "65cd92c89b65465884bc3d0395ecef55";
    const baseURL = `${EnvironmentConfig.gatewayURL}/proxy/oauth-api/v1/token`;
    let expiresIn = 900;
    const tokenExpiryBuffer = 60;
    return axios({
        url: baseURL,
        method: "post",
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            "Content-Type": "application/x-www-form-urlencoded",
            "x-proxy": EnvironmentConfig.snowProxyLiveAgentChatToken,
            "x-proxy-token": await jwtTokenFn()
        },
        data: {
            client_id,
            scope: "Eon.Chatbot.Snow",
            grant_type: "CLIENT_CREDENTIALS",
        },
    })
        .then((data) => {
            localStorage.setItem("snowBearerTokenLiveAgentChat", data.data.access_token);
            expiresIn = data.data.expires_in;
        })
        .catch((error) => {
            console.error(error);
        }).finally(() => {
            setTimeout(() => {
                HttpServicePostLiveAgentChat();
            }, (expiresIn - tokenExpiryBuffer) * 1000);
        });
};